import { render, staticRenderFns } from "./ReplyMessage.vue?vue&type=template&id=650c59f2&scoped=true"
import script from "./ReplyMessage.vue?vue&type=script&lang=js"
export * from "./ReplyMessage.vue?vue&type=script&lang=js"
import style0 from "./ReplyMessage.vue?vue&type=style&index=0&id=650c59f2&prod&lang=css"
import style1 from "./ReplyMessage.vue?vue&type=style&index=1&id=650c59f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c59f2",
  null
  
)

export default component.exports